import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { ComplexElectricityConnectionPage, ComplexElectricityConnectionPageProps } from "./ComplexElectricityConnectionPage";

export const EMPTY_PAGE_CONTENT: ComplexElectricityConnectionPageProps = {
  pageTitle: "",
};

const CANONICAL_LINK = "/personal/electricity/new-connection/complex";

export const ComplexElectricityConnectionPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<ComplexElectricityConnectionPageProps>("electricity_complex_new_connection", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <ComplexElectricityConnectionPage {...routeProps} {...content} />;
};
